import { writable } from 'svelte/store';

export const isDarkMode = writable<boolean>(false);
